<template>
  <el-select v-model="value">
    <el-option v-for="item in options"
      :key="item.id"
      :value="item.id"
      :label="item.name"
    ></el-option>
  </el-select>
</template>

<script>
const options = [
  {
    id: 1,
    name: '男'
  },
  {
    id: 0,
    name: '女'
  }
]
export default {
  name: 'Sex',
  data() {
    return {
      options: options,
      value: ''
    }
  }
}
</script>

<style>

</style>